$(document).ready(function() {
//---------vertical announcement bar--------------//
// $('.vertical_announcement_slider').slick({
//   infinite: true,
//   slidesToShow: 1,
//   slidesToScroll: 1,
//   vertical: true,
//   arrows : false,
//   autoplay: true
// });
//---------end vertical announcement bar----------//
  
//-----------Sidebar left menu js starts----------//  
  $(".mobile-menu-humburger").click(function(){
    $('#sidebar-mobile-menu').addClass("sidebar-mobile-menu-active");
  });
  $("#sidebar-mobile-menu .close-button").click(function(){
    $('#sidebar-mobile-menu').removeClass("sidebar-mobile-menu-active");
  });
//-----------Sidebar left menu js ends----------//
  
//-----------account page js starts----------//  
  $(".custom-account-page-design .account_rightbar").hide();
  $('.custom-account-page-design .cstm_dashboard').show();
  $(".custom-account-page-design .account_leftbar li").click(function(e){
    e.preventDefault();
    $(".custom-account-page-design .account_rightbar").hide();
    var attr = $(this).attr("account-attr");
    var class_attr = '.cstm_'+ attr;
    $(class_attr).show();
    $(".custom-account-page-design .account_leftbar li").removeClass('li_active');
    $(this).addClass('li_active');
  });
//-----------account page js ends----------//

//-------------add address popup js------//
  $(".custom-account-page-design .cstm_address-book .MyAccountAddressBook .MyAccountAddressTable").hide();
  $(".custom-account-page-design .cstm_address-book .add_address_button").click(function(e){
    e.preventDefault();
    $(".custom-account-page-design .cstm_address-book .MyAccountAddressBook .MyAccountAddressTable").show();
    $(".custom-account-page-design .cstm_address-book .MyAccountAddressBook .MyAccountAddressTable").addClass('Popup_isVisible');    
  });
  $(".custom-account-page-design .cstm_address-book .Popup-CloseBtn").click(function(e){ 
    $(".custom-account-page-design .cstm_address-book .MyAccountAddressBook .MyAccountAddressTable").hide();
    $(".custom-account-page-design .cstm_address-book .MyAccountAddressBook .MyAccountAddressTable").removeClass('Popup_isVisible');
  });

//-------------edit address popup js------// 
  $(".custom-account-page-design .cstm_address-book .MyAccountAddressBook .edit_address_mainDivField").hide();
  $(".custom-account-page-design .cstm_address-book .MyAccountAddressBook .edit-address").click(function(e){
    e.preventDefault();
    $(".custom-account-page-design .cstm_address-book .MyAccountAddressBook .edit_address_mainDivField").show();
    $(".custom-account-page-design .cstm_address-book .MyAccountAddressBook .edit_address_mainDivField").addClass('Popup_isVisible');   
  });
  $(".custom-account-page-design .cstm_address-book .EditPopup-CloseBtn").click(function(e){ 
    $(".custom-account-page-design .cstm_address-book .MyAccountAddressBook .edit_address_mainDivField").hide();
    $(".custom-account-page-design .cstm_address-book .MyAccountAddressBook .edit_address_mainDivField").removeClass('Popup_isVisible');
  });   

  //------collection page description read more less---------------//
  $('.collection-hero .read_more_coll_desc').click(function(){
    var coll_desc = $('.collection-hero .collection-hero__description');
    var desc_btn = $('.collection-hero .read_more_coll_desc .read_more_coll_btn');
    coll_desc.toggleClass('read_more_less_active');
    if(coll_desc.hasClass('read_more_less_active')) {
      desc_btn.text('- less');         
    } else {
      desc_btn.text('+ more');
    }
  });

  //------product page description read more less for desktop---------------//
  // $('.read_more_prod_btn').click(function(){
  $('body').on('click','.read_more_prod_btn',function() {
    var prod_desc = $('.product__info-wrapper .product__description');
    var prod_desc_btn = $('.product__info-wrapper .read_more_prod_desc .read_more_prod_btn');
    prod_desc.toggleClass('prod_read_more_active');
    if(prod_desc.hasClass('prod_read_more_active')) {
      prod_desc_btn.text('- less');         
    } else {
      prod_desc_btn.text('+ more');
    }
  });

  //------product page description read more less for mobile---------------//
  $('body').on('click','.descr_more_less_btn',function() {
    $(".product__info-wrapper .descr_more_less .descr_more_less_btn").parents(".custom_product_main_div")
      .find(".product__info-wrapper .product__description p:not(:first-child)").slideToggle();
    var prod_desc_mobile = $('.product__info-wrapper .product__description');
    var prod_desc_btn_mobile = $('.product__info-wrapper .descr_more_less .descr_more_less_btn');
    prod_desc_mobile.toggleClass('mob_prod_read_more_active');
    if(prod_desc_mobile.hasClass('mob_prod_read_more_active')) {
      prod_desc_btn_mobile.text('- less');         
    } else {
      prod_desc_btn_mobile.text('+ more');
    }
  });
  
});

//added by himanshu for more and less product description

window.addEventListener("DOMContentLoaded", function () {
  // var buttn = document.querySelectorAll(".descr_more_less_btn");
  // var count = 0;
  // if(buttn.length != 0) {
  // buttn[0].addEventListener("click", function () {
  //   alert();
  //   count = count + 1;
  //   $(".product__description p").not(':first').toggle("slow");
  //   $(".product__description ol").toggle("slow");
  //   $(this).toggleClass();
  //   if (count % 2 == 0) {
  //     $(this).text("+ more");
  //   } else {
  //     $(this).text("- less");
  //   }
  // });
  // }
  let cookies = document.cookie;
  if(cookies.includes('customer_auth_session_created_at')) {
    localStorage.setItem('Newsletter', 'false');
    $("#main-wrapper").addClass('closePopup');
  }
 $('body').on('click','.ATC__event',function() {
     
  gtag('event', 'add to cart', {'send_to': 'AW-10781125822/IkkMCNOWyPsCEL7Z65Qo'});
    });
       $('body').on('click','.checkout__button',function() {
     if(!$(this).hasClass('disabled')){
      gtag('event', 'begin_checkout', {'send_to': 'AW-10781125822/Eb_lCMOYyPsCEL7Z65Qo'});
     }
    });

});
 
var press = document.querySelectorAll('.cstm_press .image_banner_slider1');
  if(press.length != 0) {
    press.forEach((section) => {
      new Glider(section, {
          slidesToScroll: 1,
          slidesToShow: 1,
           arrows: {
          prev: '.glider-prev1',
          next: '.glider-next1'
        },
        responsive: [
          {
             breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      });
      const glider = new Glider(section, {});
      sliderAuto(glider, 2000);
    })
  }
 // best-seller--homepage-glider
  var about_us = document.querySelectorAll('.cstm_about-us .image_banner_slider1');
  if(about_us.length != 0) {
    about_us.forEach((section) => {
      new Glider(section, {
        slidesToScroll: 1,
        slidesToShow: 1,
        arrows: {
          prev: '.glider-prev2',
          next: '.glider-next2'
        },
        responsive: [{
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }]
      });
      const glider = new Glider(section, {});
      sliderAuto(glider, 2000);
    })
  }

function sliderAuto(slider, miliseconds) {
 const slidesCount = slider.track.childElementCount;
 let slideTimeout = null;
 let nextIndex = 1;

 function slide () {
   slideTimeout = setTimeout(
     function () {
       if (nextIndex >= slidesCount ) {
         nextIndex = 0;
       }
       slider.scrollItem(nextIndex++);
     },
     miliseconds
   );
 }
 slider.ele.addEventListener('glider-animated', function() {
   window.clearInterval(slideTimeout);
   slide();
 });
 slide();
}
  function closeForm(){
    localStorage.setItem('Newsletter', 'false');
    let main_wrapper = document.querySelector('#main-wrapper');
    if(main_wrapper) {
      main_wrapper.classList.add('closePopup');
    }
  }
 window.addEventListener('DOMContentLoaded', function () {
  var Newsletter_Popup = localStorage.getItem('Newsletter');
  let main_wrapper = document.querySelector('#main-wrapper');
  if(!Newsletter_Popup || Newsletter_Popup == null){
    if(main_wrapper) {
      main_wrapper.classList.remove('d-none');
    }
  } else if (Newsletter_Popup == 'false'){
    if(main_wrapper) {
      main_wrapper.classList.add('d-none');
    }
  }
  var create_customer = document.querySelector('#createCustomer');
  const firstname = document.getElementById("RegisterForm-FirstName");
  const phoneInput = document.getElementById("RegisterForm-phone");
  const emailInput = document.getElementById('RegisterForm-email');
  function checkInputs() {
    if (firstname.value === "" || phoneInput.value === "" || emailInput.value === "") {
      $('#newsLatterErrorMessage').text('Please Enter All Details').addClass('text-danger').removeClass('text-success');
      create_customer.disabled = true;
      return;
    }
    var Number = document.getElementById('RegisterForm-phone').value;
    var IndNum = /^[6-9]\d{9}$/;
    const PhoneNumber = parseInt(Number);
    if (!IndNum.test(PhoneNumber)) {
      $('#newsLatterErrorMessage').text('please enter 10 Digit valid mobile number').addClass('text-danger').removeClass('text-success');
      // document.getElementById('RegisterForm-phone').focus();
      create_customer.disabled = true;
      return;
    }
    var emailInputValue = document.getElementById('RegisterForm-email').value;
    var emailPattern = /^\w+.+@[a-zA-Z_]+?\.[a-zA-Z]{2,12}$/;
    if (!emailPattern.test(emailInputValue)) {
      $('#newsLatterErrorMessage').text('Please enter a valid email address.').addClass('text-danger').removeClass('text-success');
      create_customer.disabled = true;
      return;
    }
    var firstnameValue = document.getElementById('RegisterForm-FirstName').value;
    var pattern = /^[a-zA-Z ]+$/;
    if (!pattern.test(firstnameValue)) {
      $('#newsLatterErrorMessage').text('Please Enter Correct First Name').addClass('text-danger').removeClass('text-success');
      create_customer.disabled = true;
      return;
    }
    $('#newsLatterErrorMessage').text('').addClass('text-success').removeClass('text-danger');
    create_customer.disabled = false;
  }
  if(firstname) {
    firstname.addEventListener("input", checkInputs);
  }
  if(phoneInput) {
    phoneInput.addEventListener("input", checkInputs);
  }
  if(emailInput) {
    emailInput.addEventListener("input", checkInputs);
  }
  if(create_customer) {
    create_customer.addEventListener('click', function(event) {
      event.preventDefault();
      var data = this.closest('form');
      var firstName = data.querySelector('#RegisterForm-FirstName').value;
      var lastName = '';
      var phoneNumber = data.querySelector('#RegisterForm-phone').value;
      var Email = data.querySelector('#RegisterForm-email').value;
      var password = data.querySelector('#RegisterForm-password').value;
      var formData = {
        'form_type': 'create_customer',
        'customer[first_name]': firstName,
        'customer[last_name]': lastName,
        'customer[email]': Email,
        'customer[phone]': phoneNumber,
        'customer[password]': phoneNumber,
        'customer[tags]':"newsletter"
      };
      $.ajax({
        url: '/account',
        method: 'POST',
        data: formData,
        dataType: 'json',
        complete: function(result) {
          var response = result.responseText;
          var TextDOM = new DOMParser().parseFromString(response, 'text/html');
          var destination = document.querySelector('#Popup__form__status_error');
          var source = TextDOM.querySelector('#form__status_error');
          if(destination && source) {
            var sourceInnerhtml = source.innerHTML;
            if(sourceInnerhtml.includes('please click the link included to verify your email address.')) {
              destination.innerHTML = `You already have an existing account. Please Login`;
              destination.style.color = 'red';
            }else {
              destination.innerHTML = source.innerHTML;
              destination.style.color = 'red';
            }
          }else {
            if(destination) {
              destination.innerHTML = 'Subscribed Successfully';
              destination.style.color = 'green';
              setTimeout(() => {
                document.querySelector('#close_newsletter').dispatchEvent(new Event('click'));
              }, 2000);
            }
          }
        },
        error: function(error) {
          console.log('error: ', error.status);
        }
      });
    });
  }
 })
var collection_slider = document.querySelector('.collection_slider');
if(collection_slider) {
new Glider(document.querySelector('.collection_slider'), {
    slidesToScroll: 1,
    slidesToShow: 2,
    arrows: {
      prev: '.glider-prev',
      next: '.glider-next'
    }
  });
}
// var article_Glider = document.querySelectorAll('.articles');
// if(article_Glider.length != 0) {
//   if(window.innerWidth < 768) {
//     article_Glider.forEach((section) => {
//       new Glider(section, {
//         slidesToScroll: 1,
//         slidesToShow: 1.8,
//         arrows: {
//           prev: '.glider-prev',
//           next: '.glider-next'
//         }
//       });
//     });
//   }
// }
var homepagebanner__Glider = document.querySelectorAll('.homepagebanner');
if(homepagebanner__Glider.length != 0) {
  homepagebanner__Glider.forEach((section) => {
    new Glider(section, {
      slidesToScroll: 1,
      slidesToShow: 1,
      arrows: {
        prev: '.slideshow-glider-prev',
        next: '.slideshow-glider-next'
      }
    });
    const glider = new Glider(section, {});
    sliderAuto(glider, 5000);
  });
}

// blog-section--filter
const myElement = document.querySelector(".custom--button1");
const grab = document.querySelector(".cate-button1");
const article = document.querySelector(".custom--articles");
const pointer = document.querySelector(".loop-2");
const loop = document.querySelector(".loop-1");
const active = document.querySelectorAll(".veg");
const inactive = document.querySelectorAll(".non-veg");
const point = document.querySelector(".loop--span")

let isVeg = true; 
if(loop) {
loop.addEventListener('click', function () {
  if (isVeg) {
    active.forEach((element) => {
      element.classList.add("hide");
    });
    grab.style.right = "auto";
    grab.style.left = "5px";
    myElement.style.background = "grey";
    pointer.style.pointerEvents = "none";
  } else {
    active.forEach((element) => {
      element.classList.remove("hide");
    });
    myElement.style.backgroundColor = "#008001";
    grab.style.left = "auto";
    grab.style.right = "5px";
    pointer.style.pointerEvents = "auto";
  }
  isVeg = !isVeg;
});
}
let isNonveg = true;
if(pointer) {
pointer.addEventListener('click', function () {
  if (isNonveg) { 
    inactive.forEach((element_) => {
      element_.classList.add("hide");
    });
    point.style.right = "auto";
    point.style.left = "5px";
    pointer.style.backgroundColor = "grey";
    loop.style.pointerEvents = "none";
  } else {
    inactive.forEach((element_) => {
      element_.classList.remove("hide");
    });
    pointer.style.backgroundColor = "#C70600";
    point.style.left = "auto";
    point.style.right = "5px";
    loop.style.pointerEvents = "auto";
  }
isNonveg = !isNonveg;
});
}
// End-blog section filter
window.addEventListener('DOMContentLoaded', function () {
  var about_us = document.querySelectorAll('.article_landing');
  if (about_us.length != 0 && window.innerWidth < 768) {
    about_us.forEach((section) => {
      var thisindex = section.closest('.recipe_main_new').getAttribute('section-index');
      new Glider(section, {
        slidesToScroll: 1,
        slidesToShow: 2,
        arrows: {
          prev: `.glider-previ-${thisindex}`,
          next: `.glider-nexti-${thisindex}`
        },
        responsive: [{
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }]
      });
    });
  }
  var about_us = document.querySelectorAll('.other_glider');
  if(about_us.length != 0) {
    about_us.forEach((section) => {
      let index = section.getAttribute('section_index');
      new Glider(section, {
        slidesToScroll: 1,
        slidesToShow: 1,
        arrows: {
          prev: `.glider-prevz-${index}`,
          next: `.glider-nextz-${index}`
        },
        responsive: [{
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }]
      });
    })
  }
})
window.addEventListener('DOMContentLoaded', function() {
    var links = document.querySelectorAll('.header__menu-item');
    links.forEach((linktab) => {
        linktab.addEventListener('click', function (e) {
            e.preventDefault();
            var url = this.getAttribute('href');
            if(url != '#') {
                window.location.href = url;
            }
        });
    });
var searchInputs = document.querySelectorAll('.search__input');
var typingTimer;
var doneTypingInterval = 500;

function updateRecentSearchesDisplay() {
    var searchArray = JSON.parse(localStorage.getItem('searchArray')) || [];
    var searchRecentTitles = document.querySelectorAll('.search-recent-title');
    searchRecentTitles.forEach(function(title) {
        if (searchArray.length === 0) {
            title.style.display = 'none';
        } else {
            title.style.display = 'flex';
        }
    });

    var recentSearchesContainers = document.querySelectorAll('.st-recent-search, .st-recent-search-2');
    recentSearchesContainers.forEach(function(recentSearchesContainer) {
        recentSearchesContainer.innerHTML = '';

        searchArray.forEach(function(item, index) {
            var searchItemElement = document.createElement('span');
            searchItemElement.className = 'st-recent-search-item';

            var searchTextElement = document.createElement('span');
            searchTextElement.textContent = item;

            var removeBtn = document.createElement('button');
            removeBtn.className = 'remove-btn';
            removeBtn.textContent = 'X';
            removeBtn.addEventListener('click', function(event) {
                event.stopPropagation();
                removeSearchItem(index);
            });

            searchItemElement.appendChild(searchTextElement);
            searchItemElement.appendChild(removeBtn);
            recentSearchesContainer.appendChild(searchItemElement);

            searchItemElement.addEventListener('click', function() {
                searchInputs.forEach(function(searchInput) {
                    searchInput.value = item;
                    var event = new Event('input', {
                        bubbles: true,
                        cancelable: true,
                    });
                    searchInput.dispatchEvent(event);
                });
            });
        });
    });
}

function removeSearchItem(index) {
    var searchArray = JSON.parse(localStorage.getItem('searchArray')) || [];
    searchArray.splice(index, 1);
    localStorage.setItem('searchArray', JSON.stringify(searchArray));
    updateRecentSearchesDisplay();
}

searchInputs.forEach(function(searchInput) {
    searchInput.addEventListener('input', function(event) {
        clearTimeout(typingTimer);
        typingTimer = setTimeout(function() {
            var inputValue = event.target.value.trim();
            if (inputValue) {
                var searchArray = JSON.parse(localStorage.getItem('searchArray')) || [];
                var existingIndex = searchArray.indexOf(inputValue);
                if (existingIndex !== -1) {
                    searchArray.splice(existingIndex, 1);
                }
                searchArray.push(inputValue);
                if (searchArray.length > 5) {
                    searchArray.shift();
                }

                localStorage.setItem('searchArray', JSON.stringify(searchArray));
                updateRecentSearchesDisplay();
            }
        }, doneTypingInterval);
    });

    searchInput.addEventListener('keydown', function() {
        clearTimeout(typingTimer);
    });
});

updateRecentSearchesDisplay();

});


// pincode cart function - 13/june

window.addEventListener('DOMContentLoaded', function() {
    document.body.addEventListener('click', function(event) {
       if (event.target.classList.contains('cart__checkout-button')) {
            checkPincodeAndShowPopup(event);
        }
    });
    // document.body.addEventListener('click', function(event) {
    //     if (event.target.classList.contains('checkout__button')) {
    //          checkPincodeAndShowPopup(event);
    //     }
    // });
  
    function checkPincodeAndShowPopup(event) {
        var pincode = localStorage.getItem('locationID');
        if (pincode == null || pincode == 'No Inventory Available') {
            event.preventDefault();
            document.querySelector('.pincode-popup-container').classList.remove('d-none');
            document.querySelector('.pincode-popup-container').classList.add('d-block');
        }
    }
});

